export const ValidationLabel = 'PERSONALIZADA';
